/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import CallToAction from '../CallToAction'

const LifestyleSection = ({ cta, description, index, last, media, title }) => {
  const imageAlignment = index % 2 === 0 ? 'left' : 'right'

  return (
    <Box
      bg={imageAlignment === 'left' ? 'backgroundLight' : 'backgroundMedium'}
      sx={
        last
          ? {
              pb: '32px',
              position: 'relative',
              '&:after': {
                backgroundColor: 'white',
                backgroundImage: `url('/images/backgrounds/lifestyle-background-bottom.svg')`,
                backgroundPosition: ['top left 420px', 'top center'],
                backgroundRepeat: 'no-repeat',
                backgroundSizeX: '100%',
                backgroundSizeY: '100%',
                content: '""',
                display: 'block',
                height: '32px',
                left: '50%',
                pointerEvents: 'none',
                position: 'absolute',
                top: 'calc(100% - 32px)',
                transform: 'translateX(-50%)',
                width: ['1500px', '2000px'],
              },
            }
          : null
      }
    >
      <Container>
        <Grid
          columns={[1, 12]}
          pt={[0, index === 0 ? 9 : 7, 9, 12]}
          pb={[last ? 6 : 9, 8, 9, 10]}
          sx={{ rowGap: '0' }}
        >
          <Box
            px={[1, 0, 3, 5]}
            mt={
              index === 0
                ? ['-72px', 0, '-96px', '-128px']
                : ['-24px', 0, '-88px', '-128px']
            }
            mb={[3, 0]}
            sx={{
              gridColumn:
                imageAlignment === 'left'
                  ? [null, '1 / 6', '1 / 7', '1 / 6']
                  : [null, '8 / -1', '7 / -1', '8 / -1'],
              gridRow: [null, '1'],
            }}
          >
            <GatsbyImage
              image={media.gatsbyImageData}
              alt={media.description}
              sx={{ maxWidth: '400px', width: ['85%', '100%'] }}
            />
          </Box>
          <Box
            px={[1, 0]}
            sx={{
              gridColumn:
                imageAlignment === 'left'
                  ? [null, '6 / -1', '7 / -1', '6 / 11']
                  : [null, '1 / 8', '1 / 7', '3 / 8'],
              gridRow: [null, '1'],
            }}
          >
            <Heading as="h3" variant="title3" mb={2}>
              {title}
            </Heading>
            {description && (
              <Box
                variant="text.body2"
                mb={2}
                sx={{
                  p: {
                    my: 1,
                    '&:first-of-type': { mt: 0 },
                    '&:last-of-type': { mb: 0 },
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
            {cta && <CallToAction content={cta} type="text" />}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default LifestyleSection
